<template>
  <div>
    <h2 class="content_title">{{ headTitle }}</h2>
    <div class="select_wrap bottom_arrow bdb pl16 pr20 mt24 pb5">
      <select v-model="selectedData" @change="updateDeliveryData" class="delivery_select rb c5a">
        <option :value="data.value" v-for="data in mappedDataList" :key="data.value">{{ data.label }}</option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    headTitle: {
      type: String,
      required: true,
    },
    dataList: {
      type: Array,
      required: true,
    },
    keyMapper: {
      type: Object,
      required: true,
    },
    initialValue: {
      default: null,
    }
  },
  data() {
    return {
      selectedData: null,
    }
  },
  computed: {
    mappedDataList() {
      return this.dataList.map(item => {
        return {
          value: item[this.keyMapper.value],
          label: item[this.keyMapper.label],
        };
      });
    },
  },
  methods: {
    updateDeliveryData(event) {
      this.selectedData = event.target.value;
      this.emitData();
    },
    setInitialValue() {
      if (this.initialValue) {
        this.selectedData = this.initialValue;
        this.emitData();
      } else if (this.mappedDataList.length > 0) {
        this.selectedData = this.mappedDataList[0].value;
        this.emitData();
      }
    },
    emitData() {
      this.$emit('update-data', this.selectedData);
    },
  },
  watch: {
    dataList: {
      immediate: true,
      handler() {
        this.setInitialValue();
      },
    },
  },
  mounted() {
    this.setInitialValue();
  },
}
</script>

<style lang="css" scoped>
.content_title {
  width: 123px;
}
.delivery_select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.delivery_select {
  border: none;
  font-size: 16px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/purchase/DeliverySelectBox.vue